import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Document, Page, pdfjs } from "react-pdf";
import { FaTimes } from "react-icons/fa";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface PdfViewerModalProps {
  isOpen: boolean;
  onClose: () => void;
  pdfUrl: string;
}

const PdfViewerModal: React.FC<PdfViewerModalProps> = ({ isOpen, onClose, pdfUrl }) => {
  const [pdfWidth, setPdfWidth] = useState(600);
  const [pdfHeight, setPdfHeight] = useState(800);
  const [numPages, setNumPages] = useState<number | null>(null);

  const onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
    setNumPages(numPages);
  };

  const [modalWidth, setModalWidth] = useState("61%");
  const [pdfScale, setPdfScale] = useState(1.9);

useEffect(() => {
  const handleResize = () => {
    setModalWidth(window.innerWidth <= 950 ? "90%" : "61%");
    setPdfScale(window.innerWidth <= 950 ? 5 : 1.9);
  };

  window.addEventListener("resize", handleResize);
  handleResize(); // Llamar al inicio para aplicar el tamaño correcto

  return () => window.removeEventListener("resize", handleResize);
}, []);


  useEffect(() => {
    if (isOpen) {
      // Ajusta el tamaño del modal basado en el tamaño del PDF
      setPdfWidth(window.innerWidth * 0.3);  // 80% del ancho de la pantalla
      setPdfHeight(window.innerHeight * 0.3); // 80% de la altura de la pantalla
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Visualizador de PDF"
      ariaHideApp={false}
      style={{
        content: {
          width: modalWidth,
          height: "auto",
          margin: "auto",
          padding: "20px 20px 20px 40px",
          display: "flex",
          flexDirection: "column",
          borderRadius: "8px",
          overflow: "hidden",
          border: "none",
        },
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          color: "#d5007f",
          padding: "10px 3px 25px 0px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: "0",
          zIndex: "10",
          borderBottom: "1px solid #444",
        }}
      >
        <h3 style={{ margin: "0", fontSize: "18px" }}>Curriculum vitae</h3>
        <FaTimes
          onClick={onClose}
          style={{
            cursor: "pointer",
            fontSize: "22px",
            marginLeft: "15px",
            color: "#d5007f"
          }}
        />
      </div>
      <div style={{ overflowY: "auto", flexGrow: 1, padding: "20px" }}>
        <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}
          loading={<p style={{ textAlign: "center", color: "#d5007f", fontWeight: "bold" }}>Cargando documento...</p>}
          error={<p style={{ textAlign: "center", color: "#000000", fontWeight: "bold" }}>Error al cargar el documento. </p>}>
          {Array.from(new Array(numPages), (_, index) => (
            <Page
              key={index}
              pageNumber={index + 1}
              width={pdfWidth - 20}
              scale={pdfScale} // Aumenta la escala para mejorar la calidad
            />
          ))}
        </Document>
      </div>
    </Modal>
  );
};

export default PdfViewerModal;
